import React from 'react';
import SummatedComponent from '@crimp/lib-score-systems/dist/components/SummatedComponent';
var ListAthletesItemSummated = function (props) {
    if (!props.athleteScore) {
        return null;
    }
    var summated = typeof props.athleteScore.summated === 'string'
        ? JSON.parse(props.athleteScore.summated)
        : props.athleteScore.summated;
    return React.createElement(SummatedComponent, { scoreSystemKey: props.scoreSystemKey, summated: summated });
};
export default ListAthletesItemSummated;



//////////////////
// WEBPACK FOOTER
// ./src/imports/components/Scoreboard/components/ListAthletesItemSummated.tsx
// module id = 1020
// module chunks = 0